import React from 'react';
import { DragIndicator } from '@mui/icons-material';
import { IconButton, Typography } from '@mui/material';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';

export const CardLabel2 = ({
  label,
  dragHandleProps,
}: {
  label: string;
  dragHandleProps?: DraggableProvidedDragHandleProps | undefined;
}) => {
  return (
    <>
      <IconButton {...dragHandleProps} edge="start" aria-label="drag">
        <DragIndicator />
      </IconButton>
      <Typography variant="caption" fontWeight="500">
        {label}
      </Typography>
    </>
  );
};

export const CardLabel1 = ({
  label,
  dragHandleProps,
}: {
  label: React.ReactNode;
  dragHandleProps?: DraggableProvidedDragHandleProps | undefined;
}) => {
  return (
    <>
      <IconButton {...dragHandleProps} edge="start" aria-label="drag">
        <DragIndicator />
      </IconButton>
      {label}
    </>
  );
};
